import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { IdService } from '../../shared/services/id.service';
import { ILinkCard } from './link-card-container.types';

@Component({
	selector: 'rbc-link-card-container',
	templateUrl: './link-card-container.component.html',
	styleUrls: ['./link-card-container.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class LinkCardContainerComponent implements OnInit {
	@Input() id: string;
	@Input() title: string;
	@Input() items: ILinkCard[];
	@Input() columns: string;
	@Input() layout: string = 'card';

	constructor(private idService: IdService) {}

	ngOnInit() {
		if (!this.id) {
			this.id = this.idService.generate();
		}
	}

	cardClassGen() {
		const { layout, columns } = this;
		if (layout !== 'card') {
			return;
		}
		return {
			'card-col-my': true,
			'col-xl-3': columns === '4',
			'col-md-4': columns === '4' || columns === '3',
			'col-sm-6': columns === '4' || columns === '3' || columns === '2'
		};
	}
}
